import classNames from "classnames";
import { type ReactNode } from "react";
import styles from "./PosterWrapper.module.css"

//#region [Props]
type PosterWrapperProps = {
    className?: string;
    children: ReactNode;
};
//#endregion

//#region [Component]
export default function PosterWrapper({ className, children }: PosterWrapperProps) {
    return <div className={classNames(className, styles.PosterWrapper)}>{children}</div>;
}
//#endregion

//#region [Styles]

//#endregion